import { NumberTransferTypes } from "../../config/constants";
import {
  SET_NORMAL_CHECKOUT_CURRENT_STEP,
  SET_POST_CHECKOUT_CURRENT_STEP,
  SET_LOOKUP_DETAILS,
  SET_AUTHENTICATION_DETAILS,
  SET_SKIP_CREDIT_VETTING,
  SET_XDS_RESULT,
  SET_CREDIT_VETTING_RESULT,
  SET_NUMBER_TRANSFER_TYPE,
  SET_NUMBER_TO_TRANSFER,
  SET_NUMBER_TRANSFER_DETAILS,
  SET_PAYMENT_METHOD,
  SET_PAYMENT_METHOD_URL,
  SET_POST_ORDER_RESPONSE,
} from "../actionTypes/index";

const initialState = {
  normalCheckoutCurrentStep: null,
  postCheckoutCurrentStep: null,
  lookupDetails: null,
  authDetails: null,
  skipCreditVetting: false,
  xdsResult: null,
  creditVettingResult: null,
  numberTransferType: NumberTransferTypes.NEW_NUMBER,
  numberToTransfer: "",
  numberTransferDetails: {},
  paymentMethodCode: "checkmo",
  paymentMethodUrl: null,
  postOrderResponse: {},
};

const checkoutReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_NORMAL_CHECKOUT_CURRENT_STEP:
      return {
        ...state,
        normalCheckoutCurrentStep: payload,
      };

    case SET_POST_CHECKOUT_CURRENT_STEP:
      return {
        ...state,
        postCheckoutCurrentStep: payload,
      };

    case SET_LOOKUP_DETAILS:
      return {
        ...state,
        lookupDetails: payload,
      };

    case SET_AUTHENTICATION_DETAILS:
      return {
        ...state,
        authDetails: payload,
      };

    case SET_SKIP_CREDIT_VETTING:
      return {
        ...state,
        skipCreditVetting: payload,
      };

    case SET_XDS_RESULT:
      return {
        ...state,
        xdsResult: payload,
      };

    case SET_CREDIT_VETTING_RESULT:
      return {
        ...state,
        creditVettingResult: payload,
      };

    case SET_NUMBER_TRANSFER_TYPE:
      return {
        ...state,
        numberTransferType: payload,
      };

    case SET_NUMBER_TRANSFER_DETAILS:
      return {
        ...state,
        numberTransferDetails: payload,
      };

    case SET_NUMBER_TO_TRANSFER:
      return {
        ...state,
        numberToTransfer: payload,
      };

    case SET_PAYMENT_METHOD:
      return {
        ...state,
        paymentMethodCode: payload,
      };

    case SET_PAYMENT_METHOD_URL:
      return {
        ...state,
        paymentMethodUrl: payload,
      };

    case SET_POST_ORDER_RESPONSE:
      return {
        ...state,
        postOrderResponse: payload,
      };

    default:
      return state;
  }
};

export default checkoutReducer;
